import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';

const ReportListSearch = ({ setSearchQuery, searchQuery, disabled }) => {
	return (
		<TextField
			disabled={disabled}
			data-testid='report-search-input'
			placeholder='Search reports'
			value={searchQuery}
			onChange={(e) => setSearchQuery(e.target.value)}
			size='small'
			margin='normal'
			fullWidth
			color='primary'
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position='start'>
							<SearchIcon sx={{ fontSize: 20 }} data-testid='search-icon' />
						</InputAdornment>
					),
				},
			}}
			sx={{
				backgroundColor: disabled ? 'transparent' : 'background.paper',
				borderRadius: '8px',
				'& .MuiOutlinedInput-root': {
					borderRadius: '8px',
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: 'border.light',
					},
					'&:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: 'border.light',
					},
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: disabled ? 'border.light' : 'primary.main',
					},
				},
			}}
		/>
	);
};

ReportListSearch.propTypes = {
	searchQuery: PropTypes.string.isRequired,
	setSearchQuery: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

export default ReportListSearch;
